import { get } from './client.js'
import { bridgeParams } from './sessions.js'
import { withFreshToken } from './tokenProvider.js'

/**
 * Fetch the caller's credit usage across every candidate pool.
 * Auth params (scopedToken/apiUrl/projectCode) come from the bridge store,
 * the same values the endpoint authenticates with. Returns
 * `{ configured: false }` when credits are disabled server-side or no pool
 * matches — callers render nothing in that case.
 */
export function getCreditUsage() {
  return withFreshToken(() => get(`/credits/usage?${bridgeParams()}`))
}
